import Link from 'next/link';
import GmailIcon from '@/shared/components/icons/socials/gmail-icon';
import LinkedInIcon from '@/shared/components/icons/socials/linkedin-icon';
import TelegramIcon from '@/shared/components/icons/socials/telegram-icon';
import { Logo } from '@/shared/components/logo';
import { Button } from '@/shared/components/ui/button';
import { Separator } from '@/shared/components/ui/separator';
export const Footer = () => {
  return <footer className="border-t border-border/40 bg-background/95 pb-10 pt-6">
      <div className="container">
        <div className="grid grid-cols-1 gap-0 md:grid-cols-[minmax(150px,220px),1fr]">
          <div>
            <Logo />

            <div className="mt-2 flex items-center gap-4">
              <Link aria-label="Visit Enlerno Telegram" href={process.env.NEXT_PUBLIC_TG_URL} target="_blank" rel="noopener noreferrer" className="hover:text-brand-accent-normal dark:hover:text-brand-accent-light">
                <TelegramIcon className="h-8 w-8" />
              </Link>

              <Link aria-label="Visit Enlerno Linkedin" href={process.env.NEXT_PUBLIC_LINKEDIN_URL} target="_blank" rel="noopener noreferrer" className="hover:text-brand-accent-normal dark:hover:text-brand-accent-light">
                <LinkedInIcon className="h-8 w-8" />
              </Link>

              <Link aria-label="Write an email" href={`mailto:${process.env.NEXT_PUBLIC_GMAIL}`} target="_blank" rel="noopener noreferrer" className="hover:text-brand-accent-normal dark:hover:text-brand-accent-light">
                <GmailIcon className="h-9 w-10" />
              </Link>
            </div>

            <Separator className="my-4 w-full md:hidden" />

            <div className="mt-4 hidden select-none space-y-1 text-xs font-light tracking-tighter text-muted-foreground/80 md:block">
              <Separator className="mb-3 w-full" />

              <Button variant="link" className="p-0 text-xs font-light text-muted-foreground/80 hover:text-brand-accent-light" size="link" aria-label="Write an email">
                <Link href={`mailto:${process.env.NEXT_PUBLIC_GMAIL}`} aria-label="Write email">
                  {process.env.NEXT_PUBLIC_GMAIL}
                </Link>
              </Button>
            </div>
          </div>

          <nav className="grid w-full max-w-2xl grid-cols-1 gap-3 xss:grid-cols-2 sm:grid-cols-3 md:ml-4 md:px-2 lg:ml-20 lg:gap-2">
            <div className="mx-auto ml-0 flex w-full flex-col items-start space-y-2 xss:col-span-1 xs:col-span-2 sm:col-span-1">
              <h2 className="text-sm font-semibold lg:text-base">Documents</h2>

              <Button variant="link" size="link" className="p-0" aria-label="Legal Notice">
                <Link className="text-xs text-muted-foreground lg:text-sm" href="/legal-notice" aria-label="Legal Notice">
                  Legal Notice
                </Link>
              </Button>

              <Button variant="link" size="link" className="p-0" aria-label="Legal Notice">
                <Link className="text-xs text-muted-foreground lg:text-sm" href="/privacy-policy" aria-label="Privacy policy">
                  Privacy policy
                </Link>
              </Button>
            </div>
          </nav>

          <div className="mt-4 select-none space-y-1 text-xs font-light tracking-tighter text-muted-foreground/80 md:hidden">
            <Separator className="mb-3 w-full" />

            <Button variant="link" className="p-0 text-xs font-light text-muted-foreground/80 hover:text-brand-accent-light" size="link" aria-label="Write email">
              <Link href={`mailto:${process.env.NEXT_PUBLIC_GMAIL}`} aria-label="Write email">
                {process.env.NEXT_PUBLIC_GMAIL}
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </footer>;
};